(function (root, factory) {
  root.TBDExternalCommerce = factory();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function parseSafeHttpsUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var parsed = new URL(value.trim());
      if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function isSafeExternalUrl(value, platform) {
    var parsed = parseSafeHttpsUrl(value);
    if (!parsed) return false;
    var host = parsed.hostname.toLowerCase();
    if (platform === 'tiktok') {
      return host === 'tiktok.com' || host === 'www.tiktok.com' || host === 'shop.tiktok.com';
    }
    if (platform === 'amazon') {
      return host === 'amazon.com' || host === 'www.amazon.com' || host.endsWith('.amazon.com') || host === 'amzn.to';
    }
    return false;
  }

  function inventoryQuantity(variant) {
    var quantity = Number(variant && variant.inventory_quantity);
    return Number.isFinite(quantity) ? quantity : 0;
  }

  function getPurchaseState(variant, links, options) {
    var settings = options || {};
    var quantity = inventoryQuantity(variant);
    var nativeAvailable = !settings.priceRequired && Boolean(variant && variant.available) && quantity > 0;
    var externalEligible = quantity <= 0;
    var tiktok = externalEligible && isSafeExternalUrl(links && links.tiktok, 'tiktok');
    var amazon = externalEligible && isSafeExternalUrl(links && links.amazon, 'amazon');
    var mode = nativeAvailable ? 'native' : (tiktok || amazon ? 'external' : 'unavailable');
    return {
      mode: mode,
      nativeAvailable: nativeAvailable,
      externalEligible: externalEligible,
      showTikTok: tiktok,
      showAmazon: amazon,
      inventoryQuantity: quantity
    };
  }

  return {
    getPurchaseState: getPurchaseState,
    inventoryQuantity: inventoryQuantity,
    isSafeExternalUrl: isSafeExternalUrl
  };
});
